import axios from 'src/utils/axios';
import authService from 'src/services/authService';
import { addNotification } from 'src/actions/notificationActions';
import { NOTIFICATION_STATUS, POST_HEADER } from 'src/constants';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const RESET_PASSWORD = '@account/reset-password';
export const UPDATE_PROFILE = '@account/update-profile';
export const AGREE_TO_TERMS_OF_SERVICE = '@account/agree-to-terms-of-service';
export const GET_ACCOUNT_INFO = '@account/get-account-info';

export const GET_USERS_LIST = '@account/get-users-list';
export const GET_USERS_LIST_SUCCESS = '@account/get-users-list-success';
export const GET_USERS_LIST_ERROR = '@account/get-users-list-error';

export const SIGN_IN_AS_USER = '@account/sign-in-as-user';
export const SIGN_IN_AS_USER_SUCCESS = '@account/sign-in-as-user-success';
export const SIGN_IN_AS_USER_ERROR = '@account/sign-in-as-user-error';

export const SET_USER_WAS_SHOWN_ERRORS = '@account/set-user-was-shown-errors';

export const CHANGE_COMPANY_TITLE = '@account/change-company-title';
export const CHANGE_COMPANY_TITLE_SUCCESS = '@account/change-company-title-success';
export const CHANGE_COMPANY_TITLE_ERROR = '@account/change-company-title-error';

export const GET_EMAIL_TOKEN = '@account/get-email-token';
export const GET_EMAIL_TOKEN_SUCCESS = '@account/get-email-token-success';
export const GET_EMAIL_TOKEN_ERROR = '@account/get-email-token-error';

export const SET_GET_USERS_EMAIL_TOKEN = '@account/set-get-users-email-token';

export const SET_EMAIL_TOKEN_ERROR_MESSAGE = '@account/set-email-token-error-message';

export const CHANGE_CAMPAIGNS = '@account/change-campaigns';
export const CHANGE_CAMPAIGNS_SUCCESS = '@account/change-campaigns-success';
export const CHANGE_CAMPAIGNS_ERROR = '@account/change-campaigns-error';

export const SOCKET_SMS_RATE_LIMITS = '@account/socket-sms-rate-limits';

export const ENABLE_CP_TEXTING = '@account/enable-cp-texting';
export const ENABLE_CP_TEXTING_SUCCESS = '@account/enable-cp-texting-success';
export const ENABLE_CP_TEXTING_ERROR = '@account/enable-cp-texting-error';

export const DISMISS_ENABLE_CP_TEXTING = '@account/dismiss-enable-cp-texting';

export const DISMISS_PB_TEXTING_MODAL = '@account/dismiss-pb-texting-modal';
export const DISMISS_PB_TEXTING_MODAL_SUCCESS = '@account/dismiss-pb-texting-modal-success';
export const DISMISS_PB_TEXTING_MODAL_ERROR = '@account/dismiss-pb-texting-modal-error';
export const DISMISS_PB_TEXTING_BANNER_SESSION = '@account/dismiss-pb-texting-banner-session';
export const SHOW_PB_TEXTING_MODAL = '@account/show-pb-texting-modal';

export const DISMISS_WHATS_NEW = '@account/dismiss-whats-new';
export const DISMISS_WHATS_NEW_BANNER_SESSION = '@account/dismiss-whats-new-banner-session';
export const SHOW_WHATS_NEW = '@account/show-whats-new';
export const UPDATE_WHATS_NEW = '@account/update-whats-new';
export const SET_WHATS_NEW_HISTORY = '@account/set-whats-new-history';
export const CLOSE_WHATS_NEW_HISTORY = '@account/close-whats-new-history';

export const DISMISS_SHARE_SET_UPDATES = '@account/dismiss-share-set-updates';

export const getAccountInfo = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/account/me');
    const error = response?.data?.error;
    if (!error) {
      dispatch({
        type: GET_ACCOUNT_INFO,
        payload: response?.data,
      });
      return;
    }
    dispatch(addNotification(GET_ACCOUNT_INFO, response?.data?.error || 'Server error', NOTIFICATION_STATUS.ERROR));
  } catch (e) {
    dispatch(addNotification(GET_ACCOUNT_INFO, 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

export function login(values) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const {
        email,
        password,
        confirmPassword,
      } = values || {};

      const payload = await authService.loginWithEmailAndPassword(email, password, !!confirmPassword);

      dispatch({
        type: LOGIN_SUCCESS,
        payload
      });
      dispatch(getAccountInfo());
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export const resetPassword = (accountChanges, tryMessage, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    const response = await axios.post('/api/account/pwdchange', accountChanges, POST_HEADER);
    const error = response?.data?.error;

    if (error) {
      dispatch(addNotification(RESET_PASSWORD, error, NOTIFICATION_STATUS.ERROR));
      return;
    }

    dispatch(addNotification(RESET_PASSWORD, tryMessage, NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(RESET_PASSWORD, error || 'Try again later', NOTIFICATION_STATUS.ERROR));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export function setUserData(payload) {
  return (dispatch) => dispatch({
    type: SILENT_LOGIN,
    payload,
  });
}

export function logout() {
  return async (dispatch) => {
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(update) {
  const request = axios.post('/api/account/profile', { update });

  return (dispatch) => {
    request.then((response) => dispatch({
      type: UPDATE_PROFILE,
      payload: response.data
    }));
  };
}

// export const getAccountInfo = () => async (dispatch) => {
//   try {
//     const response = await axios.get('/api/account/me');
//     const error = response?.data?.error;
//     if (!error) {
//       dispatch({
//         type: GET_ACCOUNT_INFO,
//         payload: response?.data,
//       });
//       return;
//     }
//     dispatch(addNotification(GET_ACCOUNT_INFO, response?.data?.error || 'Server error', NOTIFICATION_STATUS.ERROR));
//   } catch (e) {
//     dispatch(addNotification(GET_ACCOUNT_INFO, 'Server error', NOTIFICATION_STATUS.ERROR));
//   }
// };

export const getUsersList = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_USERS_LIST,
    });
    const response = await axios.get('/api/account/accountlist');
    const { error, message } = response?.data || {};
    if (error || message) {
      dispatch(addNotification(GET_USERS_LIST_ERROR, error || message, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_USERS_LIST_ERROR,
      });
      return;
    }
    dispatch({
      type: GET_USERS_LIST_SUCCESS,
      payload: response?.data?.users || [],
    });
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(GET_USERS_LIST_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_USERS_LIST_ERROR,
    });
  }
};

export const agreeToTermsOfService = () => async (dispatch) => {
  try {
    const response = await axios.post('/api/account/tosps', {});
    if (response?.data?.success) {
      dispatch(getAccountInfo());
      return;
    }
    dispatch(addNotification(AGREE_TO_TERMS_OF_SERVICE, response?.data?.error || 'Server error', NOTIFICATION_STATUS.ERROR));
  } catch (e) {
    dispatch(addNotification(GET_ACCOUNT_INFO, 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

// CON-1966. The Return button's label: "Support" for the shared support
// account, otherwise the original account's first name.
const SUPPORT_ACCOUNT_EMAIL = 'support@connectionpointsoftware.com';
const signInAsReturnLabel = (user) => {
  if (String(user?.email || '').toLowerCase() === SUPPORT_ACCOUNT_EMAIL) return 'Support';
  return user?.firstName || 'Support';
};

export const signInAsUser = (accountChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SIGN_IN_AS_USER,
    });
    // CON-1966. Already signed in as someone: ask as the original account,
    // which keeps its saved session (no chaining).
    const original = authService.getSignInAsOriginal();
    const response = await axios.post(
      '/api/account/signinasuser',
      accountChanges,
      original ? { headers: { Authorization: `Bearer ${original.token}` } } : undefined,
    );
    const { error, message } = response?.data || {};

    if (error || message) {
      dispatch(addNotification(SIGN_IN_AS_USER_ERROR, error || message, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SIGN_IN_AS_USER_ERROR,
      });
      return;
    }

    const { accessToken } = response?.data || {};
    authService.startSignInAs(accessToken, signInAsReturnLabel(getState()?.account?.user));

    dispatch({
      type: SIGN_IN_AS_USER_SUCCESS,
      payload: response?.data,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(SIGN_IN_AS_USER_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SIGN_IN_AS_USER_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const changeCompanyTitle = (sendData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CHANGE_COMPANY_TITLE,
    });
    const {
      companyTitle,
    } = sendData || {};
    const response = await axios.post('/api/accountSettings/changeCompanyTitle', { companyTitle });
    const { error, message } = response?.data || {};

    if (error || message) {
      dispatch(addNotification(CHANGE_COMPANY_TITLE_ERROR, error || message || 'Could not update your title. Try again or Contact Support.', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CHANGE_COMPANY_TITLE_ERROR,
      });
      return;
    }

    dispatch({
      type: CHANGE_COMPANY_TITLE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(CHANGE_COMPANY_TITLE_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CHANGE_COMPANY_TITLE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const changeCampaign = (sendData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CHANGE_CAMPAIGNS,
    });
    const response = await axios.post('/api/accountSettings/changeCampaigns', { sendData });
    const { error, message } = response?.data || {};

    if (error || message) {
      dispatch(addNotification(CHANGE_CAMPAIGNS_ERROR, error || message || 'Could not update your campaigns. Try again or Contact Support.', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CHANGE_CAMPAIGNS_ERROR,
      });
      return;
    }

    dispatch({
      type: CHANGE_CAMPAIGNS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(CHANGE_CAMPAIGNS_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CHANGE_CAMPAIGNS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getEmailTokenFromAccessCode = (sendData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: GET_EMAIL_TOKEN,
    });
    const response = await axios.post('/api/accountSettings/emailAccessCode', sendData);
    const { error, message } = response?.data || {};

    if (error || message) {
      dispatch(addNotification(GET_EMAIL_TOKEN_ERROR, error || message || 'Could not set up your email. Try again or Contact Support.', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_EMAIL_TOKEN_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_EMAIL_TOKEN_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      screenMessage,
    } = e?.response?.data || {};
    const messages = {
      screenMessage,
      message,
    };
    dispatch(addNotification(GET_EMAIL_TOKEN_ERROR, message || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_EMAIL_TOKEN_ERROR,
      payload: messages || null,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const enableCPTexting = (doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: ENABLE_CP_TEXTING,
    });
    const response = await axios.post('/api/accountSettings/enableCPTexting', {});
    const { error, success } = response?.data || {};

    // Check for error OR lack of success, not just presence of message
    if (error || !success) {
      const errorMessage = error || 'Could not enable CP texting. Try again or Contact Support.';
      dispatch(addNotification(ENABLE_CP_TEXTING_ERROR, errorMessage, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: ENABLE_CP_TEXTING_ERROR,
      });
      return;
    }

    dispatch(addNotification(ENABLE_CP_TEXTING_SUCCESS, 'CP Texting has been successfully enabled!', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: ENABLE_CP_TEXTING_SUCCESS,
    });

    // Refresh account info to get updated user data (this will update textingProvider and userRole)
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(ENABLE_CP_TEXTING_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: ENABLE_CP_TEXTING_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setGetUsersEmailToken = (show) => ({
  type: SET_GET_USERS_EMAIL_TOKEN,
  payload: show,
});

export const setEmailTokenError = () => ({
  type: SET_EMAIL_TOKEN_ERROR_MESSAGE,
});

export const setUserWasShownErrors = (errors) => (dispatch) => dispatch({
  type: SET_USER_WAS_SHOWN_ERRORS,
  payload: errors,
});

export const socketSMSRateLimits = (rateLimits) => async (dispatch) => {
  dispatch({
    type: SOCKET_SMS_RATE_LIMITS,
    payload: rateLimits,
  });
};

export const dismissEnableCPTexting = () => ({
  type: DISMISS_ENABLE_CP_TEXTING,
});

export const dismissPBTextingModal = () => async (dispatch) => {
  // Immediately hide the modal in the UI
  dispatch({ type: DISMISS_PB_TEXTING_MODAL });

  // Track the dismissal in the backend (fire and forget - don't block UI)
  try {
    await axios.post('/api/accountsettings/pb-texting-modal-dismissed', {});
    dispatch({ type: DISMISS_PB_TEXTING_MODAL_SUCCESS });
  } catch (e) {
    // Log error but don't disrupt the user experience
    console.error('Failed to track modal dismissal:', e);
  }
};

/* CON-1674 — the voice memo charge disclosure.
 *
 * Deliberately NOT redux-backed state: it is read once when the compose box
 * mounts and written once when the consultant accepts, so a reducer would add
 * a store shape for two booleans. Both are plain promises the caller awaits.
 *
 * The read FAILS OPEN — an error resolves to false, meaning the notice is
 * shown. Showing it twice is a small annoyance; skipping it because a request
 * failed would charge someone who was never told. */
export const fetchVoiceMemoDisclosure = async () => {
  try {
    const { data } = await axios.get('/api/accountsettings/voice-memo-disclosure');
    return !!data?.acknowledged;
  } catch (e) {
    return false;
  }
};

export const acknowledgeVoiceMemoDisclosure = async () => {
  try {
    await axios.post('/api/accountsettings/voice-memo-disclosure', {});
    return true;
  } catch (e) {
    // The consultant has seen and accepted the notice; failing to persist that
    // must not block the recording they asked for. They will simply be asked
    // once more next time.
    console.error('Failed to record the voice memo acknowledgement:', e);
    return false;
  }
};

export const dismissPBTextingBannerForSession = () => ({
  type: DISMISS_PB_TEXTING_BANNER_SESSION,
});

export const showPBTextingModal = () => ({
  type: SHOW_PB_TEXTING_MODAL,
});

export const dismissWhatsNew = (permanentlyDismiss = false) => async (dispatch) => {
  dispatch({ type: DISMISS_WHATS_NEW, payload: { permanentlyDismiss } });

  try {
    await axios.post('/api/whats-new/dismissed', { permanentlyDismiss });
  } catch (e) {
    console.error('Failed to track What\'s New dismissal:', e);
  }
};

export const dismissWhatsNewBannerForSession = () => ({
  type: DISMISS_WHATS_NEW_BANNER_SESSION,
});

export const showWhatsNew = () => ({
  type: SHOW_WHATS_NEW,
});

export const pollWhatsNewStatus = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/whats-new/status');
    if (response?.data) {
      dispatch({
        type: UPDATE_WHATS_NEW,
        payload: response.data,
      });
    }
  } catch (e) {
    // Silently fail — polling should not disrupt the user
  }
};

export const fetchWhatsNewHistory = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/whats-new/history');
    if (response?.data?.features) {
      dispatch({
        type: SET_WHATS_NEW_HISTORY,
        payload: { features: response.data.features },
      });
    }
  } catch (e) {
    console.error('Failed to fetch What\'s New history:', e);
  }
};

export const closeWhatsNewHistory = () => ({
  type: CLOSE_WHATS_NEW_HISTORY,
});

// CON-1552 Chunk 6 Stage C — "Not now" on the Set-updates sign-in notice:
// hide the modal and stamp lastNotifiedVersionId so the recipient is not
// re-prompted until the author publishes again (fire and forget). `sets` is
// the [{ shareSetId, latestVersionId }] that was shown.
export const dismissShareSetUpdates = (sets = []) => async (dispatch) => {
  dispatch({ type: DISMISS_SHARE_SET_UPDATES });

  try {
    await axios.post('/api/share-sets/updates/dismissed', { sets });
  } catch (e) {
    console.error('Failed to dismiss Set update notices:', e);
  }
};

// CON-1552 Chunk 6 Stage C — "Stop notifying me about this Set": the
// permanent opt-out (flips subscribeToUpdates=false). Separate from the
// dedup dismiss above. Fire and forget.
export const unsubscribeFromShareSetUpdates = (shareSetId) => async () => {
  try {
    await axios.post('/api/share-sets/updates/unsubscribe', { shareSetId });
  } catch (e) {
    console.error('Failed to unsubscribe from Set updates:', e);
  }
};

// CON-1966. Return to Support: switch back to the original account's saved
// session and record it, then a full page load of /app so nothing from the
// consultant's session stays in memory. If the original session has
// expired, both are cleared and the browser goes to the login page.
export const returnFromSignInAs = (targetUserId) => async () => {
  if (!authService.returnFromSignInAs()) {
    window.location.assign('/login');
    return;
  }
  try {
    await axios.post('/api/account/signInAsReturn', { targetUserId });
  } catch (error) {
    // A 401 here means the original session was refused: the axios
    // interceptor has already cleared it, and /app will send to login.
  }
  window.location.assign('/app');
};
